import { Language, PresentationType, VIEWPORTS } from '@constants';
import { 
    ActionTypes, 
    PointerPosition, 
    SetLanguageAction, 
    SetPdfPageAction, 
    SetPresentationIdAction, 
    SetShowPointerAction, 
    SetSlideIdAction, 
    UpdateVideoDataAction, 
    UpdatePointerPositionAction, 
    VideoData, 
    SelectTermAction,
    SetPresentationEndedAction,
    SetPresentationTypeAction,
    SelectSlideSectionAction,
    setStepsReviewedAction,
    SelectInfoItemAction,
    SetClientConnectedAction,
    SetRepConnectedAction,
    SetLoanInputAction,
    SetSlideWidthAction,
    SetScrollLeftAction,
    SetScrollTopAction,
    LoanCalculations,
    SetLoanCalculationsAction,
    setAvailableTermsAction,
    setLastSlideIdAction} from './types';

export const setShowPointer = (showPointer: boolean): SetShowPointerAction => ({ type: ActionTypes.SHOW_POINTER, showPointer });
export const updatePointerPosition = (position: PointerPosition): UpdatePointerPositionAction => ({type: ActionTypes.UPDATE_POINTER_POSITION, position });
export const updateVideoData = (videoData: VideoData): UpdateVideoDataAction => ({ type: ActionTypes.UPDATE_VIDEO_DATA, videoData });
export const setSlideId = (slideId: number): SetSlideIdAction => ({ type: ActionTypes.SET_SLIDE_ID, slideId });
export const setLastSlideId = (lastSlideId: number): setLastSlideIdAction => ({ type: ActionTypes.SET_LAST_SLIDE_ID, lastSlideId });
export const setPdfPage = (page: number): SetPdfPageAction => ({ type: ActionTypes.UPDATE_PDF_PAGE, page });
export const selectTerm = (term: number, slideId: number): SelectTermAction => ({ type: ActionTypes.SELECT_TERM, term, slideId });
export const setPresentationEnded = (presentationEnded: boolean): SetPresentationEndedAction => ({ type: ActionTypes.END_PRESENTATION, presentationEnded });
export const setViewport = (viewport: VIEWPORTS) => ({ type: ActionTypes.SET_VIEWPORT, viewport });
export const setPresentationType = (presentationType: PresentationType): SetPresentationTypeAction => ({ type: ActionTypes.SET_PRESENTATION_TYPE, presentationType });
export const selectSlideSection = (id: number, section: number): SelectSlideSectionAction => ({ type: ActionTypes.SELECT_SECTION, id, section });
export const setStepsReviewed = (id: number, step: string): setStepsReviewedAction => ({ type: ActionTypes.SET_STEP_REVIEWED, id, step });
export const selectInfoItem = (item: string): SelectInfoItemAction => ({ type: ActionTypes.SELECT_INFO_ITEM, item });
export const setLoanInput = (name: string, value: string): SetLoanInputAction => ({ type: ActionTypes.SET_LOAN_INPUT, name, value });
export const setLoanCalculations = (calculations: LoanCalculations): SetLoanCalculationsAction => ({ type: ActionTypes.SET_LOAN_CALCULATIONS, calculations });
export const setClientConnected = (connected: boolean): SetClientConnectedAction => ({ type: ActionTypes.SET_CLIENT_CONNECTED, connected });
export const setRepConnected = (connected: boolean): SetRepConnectedAction => ({ type: ActionTypes.SET_REP_CONNECTED, connected });
export const setSlideWidth = (width: number): SetSlideWidthAction => ({ type: ActionTypes.SET_SLIDE_WIDTH, width });
export const setAvailableTerms = (terms: number[]): setAvailableTermsAction => ({ type: ActionTypes.SET_AVAILABLE_TERMS, terms });
export const setScrollTop = (elementId: string, top: number): SetScrollTopAction => ({ type: ActionTypes.SET_SCROLL_TOP, elementId, top });
export const setScrollLeft = (elementId: string, left: number): SetScrollLeftAction => ({ type: ActionTypes.SET_SCROLL_LEFT, elementId, left });
export const setLanguage = (language: Language): SetLanguageAction => ({ type: ActionTypes.SET_LANGUAGE, language });
export const setPresentationId = (presentationId: number): SetPresentationIdAction => ({ type: ActionTypes.SET_PRESENTATION_ID, presentationId });

